'use client';

import HeroSection from './HeroSection';
import PackagesSection from './PackagesSection';
import AmenitiesSection from './AmenitiesSection';
import BenefitsSection from './BenefitsSection';
import CTASection from './CTASection';
import Footer from '@/app/guest-stories/components/Footer';

export default function CorporateSolutionsInteractive() {
  return (
    <>
      <HeroSection />
      <PackagesSection />
      <AmenitiesSection />
      <BenefitsSection />
      <CTASection />
      <Footer />
    </>
  );
}